<script setup>
import DownloadBanner from "@/components/banner/DownloadBanner.vue";
import GlobalBreadcrumbs from "@/components/layout/GlobalBreadcrumbs.vue";
import AppBanner from "@/components/layout3/app/AppBanner.vue";
import AppFooter from "@/components/layout3/app/AppFooter.vue";
import AppNavbar from "@/components/layout3/app/AppNavbar.vue";
import NotificationComponent from "@/components/partials/NotificationComponent.vue";
import NotificationDialog from "@/components/partials/NotificationDialog.vue";
import { useLayout2HomeTabsStore } from "@/modules/Layout2/stores/useLayout2HomeTabs.store";
import eventBus from "@/plugins/eventBus";
import WeeklyReportSettings from "@/components/layout/WeeklyReportSettings.vue";
import { storeToRefs } from "pinia";
import { inject } from "vue";
import { onBeforeMount, onMounted, provide, ref } from "vue";

const layout2Store = useLayout2HomeTabsStore();
const { selectedMainTab } = storeToRefs(layout2Store);

const appleStore = inject("appleStore", "");

/**
 * Notification Dialog
 */
const notification = ref({
  message: "",
  show: false,
  icon: true,
});
const banner = ref(false);

onBeforeMount(() => {
  selectedMainTab.value = "featured";
  document.documentElement.style.setProperty("--el-color-primary", "#012D74");
  document.documentElement.style.setProperty("--main-bg-color", "#012D74");
  document.documentElement.style.setProperty(
    "--el-color-primary-light-3",
    "#6A80A8"
  );
  document.documentElement.style.setProperty(
    "--el-color-primary-light-5",
    "#F2F4F7"
  );
  document.documentElement.style.setProperty(
    "--el-color-primary-light-7",
    "#899EBE"
  );
  document.documentElement.style.setProperty(
    "--el-color-primary-light-8",
    "#D0D5DD"
  );
  document.documentElement.style.setProperty(
    "--el-color-primary-light-9",
    "#EAECF0"
  );
  document.documentElement.style.setProperty(
    "--el-color-primary-dark-2",
    "#98A2B3"
  );
  document.documentElement.style.setProperty("--el-button--primary", "#012D74");
});

const click_close_banner = () => {
  banner.value = !banner.value;
};

onMounted(() => {
  eventBus.$on("NOTIFICATION_DIALOG", (data) => {
    notification.value = {
      show: true,
      message: data.message,
      icon: data.icon,
    };
  });
});

provide("isDynamicLayout", true);
</script>
<template>
  <div class="min-h-screen flex flex-col">
    <AppBanner />
    <AppNavbar />

    <div class="flex-1 bg-untitled-gray-50 flex flex-col">
      <GlobalBreadcrumbs v-if="$auth.check()" />
      <main
        class="flex-1 flex flex-col"
        :class="{
          'py-3': $route.name !== 'home',
        }"
      >
        <!-- <router-view /> -->
         <slot />
      </main>
    </div>
    <NotificationDialog
      v-if="notification.show"
      :content="notification.message"
      :icon="notification.icon"
      @close="notification.show = false"
    ></NotificationDialog>
    <AppFooter />
    <DownloadBanner
      v-model="banner"
      :handleCloseBanner="click_close_banner"
      :link="appleStore"
    />
    <NotificationComponent />

    <WeeklyReportSettings />
  </div>
</template>
<style lang="css"></style>
